import { AxiosCall, AxiosPatch, AxiosPost } from '../../../utils/axios';

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  if (params.status && params.status !== 'all') {
    searchParams.append('status', params.status);
  }

  if (params.type) {
    searchParams.append('alert_type', params.type);
  }

  if (params.search) {
    searchParams.append('search', params.search);
  }

  if (params.organization && String(params.organization).toLowerCase() !== 'all') {
    searchParams.append('organization', params.organization);
  }

  if (params.show_scheduled) {
    searchParams.append('show_scheduled', params.show_scheduled);
  }

  // Add limit if specified (for 'all' tab)
  if (params.limit) {
    searchParams.append('limit', params.limit);
  }

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

export const fetchAlerts = (params) => AxiosCall(`/mycore/alerts/${buildQueryString(params)}`);

export const fetchAlertDetail = (alertId) => AxiosCall(`/mycore/alerts/${alertId}/`);

export const resolveAlert = (alertId) => AxiosPatch(`/mycore/alerts/${alertId}/resolve/`, {});

export const dismissAlert = (alertId) => AxiosPatch(`/mycore/alerts/${alertId}/dismiss/`, {});

export const activateNextRecurrence = (alertId) => AxiosPost(`/mycore/alerts/${alertId}/activate-next-recurrence/`, {});

export const createAlert = (payload) => AxiosPost('/mycore/alerts/', payload);

export const markAlertRead = (alertId) => AxiosPost(`/mycore/alerts/${alertId}/mark-read/`, {});

export const markAllAlertsRead = () => AxiosPost('/mycore/alerts/mark-all-read/', {});

export const fetchUnreadCount = () => AxiosCall('/mycore/alerts/unread-count/');

export const advanceBatchFromAlert = (alertId) => AxiosPost(`/mycore/alerts/${alertId}/advance-batch/`, {});

export default {
  fetchAlerts,
  fetchAlertDetail,
  resolveAlert,
  dismissAlert,
  activateNextRecurrence,
  createAlert,
  markAlertRead,
  markAllAlertsRead,
  fetchUnreadCount,
  advanceBatchFromAlert,
};
